const DEFAULT_COLOR = "#64748b";

function parseHex(hex: string): { r: number; g: number; b: number } | null {
  const match = hex.replace(/^#/, "").match(/^([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/);
  if (!match) return null;
  let h = match[1];
  if (h.length === 3) {
    h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
  }
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return { r, g, b };
}

export function hexToRgba(hex: string, alpha: number): string {
  const rgb = parseHex(hex);
  if (!rgb) return `rgba(100, 116, 139, ${alpha})`;
  return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha})`;
}

export function normalizeHex(hex: string): string {
  const rgb = parseHex(hex);
  if (!rgb) return DEFAULT_COLOR;
  return `#${[rgb.r, rgb.g, rgb.b].map((c) => c.toString(16).padStart(2, "0")).join("")}`;
}

export function getStatusColor(statusOrKey: string): string {
  return STATUS_COLORS[statusOrKey] ?? DEFAULT_COLOR;
}

export const STATUS_COLORS: Record<string, string> = {
  OPEN: "#7c3aed",
  IN_PROGRESS: "#0d9488",
  SCHEDULED: "#6366f1",
  WAITING_FOR_SPARE_PARTS: "#ea580c",
  QUESTION: "#0891b2",
  CLOSED: "#64748b",
  RESOLVED: "#22c55e",
  NEW: "#7c3aed",
  PENDING: "#f59e0b",
  PROMOTED: "#22c55e",
  DISCARDED: "#64748b",
  LOW: "#22c55e",
  MEDIUM: "#2563eb",
  HIGH: "#f59e0b",
  CRITICAL: "#dc2626",
  critical: "#ef4444",
  low: "#f59e0b",
  ok: "#22c55e",
  none: "#64748b",
  ordered: "#f59e0b",
  delivered: "#22c55e",
  open: "#f59e0b",
  completed: "#22c55e",
  inactive: "#64748b",
  INACTIVE: "#64748b",
  active: "#22c55e",
  scrapped: "#64748b",
  overdue: "#ef4444",
  due: "#f59e0b",
  upcoming: "#3b82f6",
  scheduled: "#64748b",
  booking_in: "#22c55e",
  booking_out: "#64748b",
  order: "#3b82f6",
};
